import '../src/base';
import '~/app/assets/javascripts/application/sitewide';
import '~/app/assets/javascripts/application/financial_aid/main';
import '~/app/assets/javascripts/application/financial_aid/lead_assistant';
import '~/app/assets/javascripts/application/shared/lead';
import '~/app/assets/javascripts/application/shared/search_form';
import '~/app/assets/javascripts/application/shared/manual_tracking';
